/** Shop page hero, feature cards, trust badges, and policy page boilerplate. */
export const STORE_COPY_DEFAULTS = {
  shop_eyebrow: 'Saloni Designs',
  shop_title: 'Handcrafted collections',
  shop_subtitle:
    'Rakhi, Lumba, and more — each piece made with care. Open a category to explore styles and designs.',
  shop_section_heading: 'Browse by category',
  shop_section_lead:
    'Tap a collection to see everything inside — including kids, personalized, and festive styles.',
  shop_features: [
    {
      icon: '🎨',
      title: 'Handcrafted Quality',
      desc: 'Each piece is lovingly created by skilled artisans',
    },
    {
      icon: '🚚',
      title: 'Fast Delivery',
      desc: 'Quick and secure shipping across India',
    },
    {
      icon: '💝',
      title: 'Custom Orders',
      desc: 'Personalized designs for special occasions',
    },
  ],
  trust_badge_1: 'Ships across India',
  trust_badge_2: 'Secure checkout',
  trust_badge_3: 'Handcrafted quality',
  policy_page_lead: 'Last updated for the Saloni Designs online shop.',
  policy_page_footer: 'Questions? Contact us or message us on WhatsApp.',
  footer_made_in: 'Handcrafted in India',
  pdp_about_heading: 'About this piece',
  pdp_shipping_heading: 'Shipping & delivery',
  pdp_shipping_note: 'Ships across India',
  pdp_returns_heading: 'Returns & care',
  pdp_returns_note: 'Handcrafted pieces — see our return policy for eligible items.',
  pdp_bullets: [
    { text: 'Handcrafted in India', link_label: '', link_href: '' },
    {
      text: 'Ships across India — see',
      link_label: 'shipping',
      link_href: '/policies/shipping',
    },
    { text: 'Secure checkout or offline payment options', link_label: '', link_href: '' },
  ],
  whatsapp_product_template: "Hi, I'm interested in {title} (ID: {id}) on Saloni Designs.",
  category_tagline_rakhi: 'Handcrafted rakhi for every bond',
  category_tagline_lumba: 'Elegant lumba for celebrations',
  cart_title: 'Your bag',
  cart_nonempty_lead: 'Adjust quantities or remove items before checkout.',
  cart_empty_title: 'Your bag is empty',
  cart_empty_lead_default:
    'Explore our collections and add pieces you love. Every item is crafted for Raksha Bandhan and festive gifting.',
  cart_empty_lead_stock:
    'Some items in your bag are no longer available or quantities were reduced to match stock. Review the shop and add items again.',
  cart_empty_lead_checkout:
    'Your bag is empty — add items from the shop to continue to checkout. If you just placed an order, check your confirmation email or My account for order status.',
  order_success_paid_message:
    'Payment received. We are preparing your order and will email you when it ships.',
  notfound_title: 'This page could not be found',
  notfound_lead:
    'The link may be outdated, or the page may have moved. Browse our handcrafted Rakhi and Lumba collections instead.',
  notfound_shop_button: 'Shop collections',
  notfound_home_button: 'Back to home',
  seo_cart_title: 'Your bag | Saloni Designs',
  seo_cart_description: 'Review items in your Saloni Designs shopping bag.',
  seo_checkout_title: 'Checkout | Saloni Designs',
  seo_checkout_description: 'Secure checkout for handcrafted Rakhi and Lumba orders.',
  seo_wishlist_title: 'Saved items | Saloni Designs',
  seo_wishlist_description: 'Your saved Rakhi and Lumba pieces at Saloni Designs.',
  seo_order_success_title: 'Order confirmed | Saloni Designs',
  seo_notfound_title: 'Page not found | Saloni Designs',
  seo_search_title: 'Search products',
  seo_search_description: 'Search our handcrafted catalog by product name or ID.',
  seo_track_order_title: 'Track your order',
  seo_track_order_description: 'Look up your Saloni Designs order status with your order number and email.',
  seo_account_title: 'My account',
  seo_account_description: 'View orders, saved items, and account details.',
  seo_blog_title: 'Styling ideas & stories',
  seo_blog_description: 'Tips for choosing jewelry and festive gifting from our studio.',
  seo_pdp_title_template: '{title} | {category} | {brand}',
  seo_pdp_description_template: '{description}',
};
